import {useEffect, useRef} from 'react';

const useEffectOnUpdate = (callback, deps) => {
    const prevDepsRef = useRef(deps);
    
    useEffect(() => {
        if(prevDepsRef.current === deps) {
            return;
        }
        return callback();
    }, deps);
};

export default useEffectOnUpdate;